import ApiService from "@/api.service";

export const UPLOAD_FILE = "/upload-file";
export const UPDATE_FILE = "/admin/portpolio/1";
const state = {};

const getters = {};

const actions = {

    [UPLOAD_FILE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${UPLOAD_FILE}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [UPDATE_FILE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.put(`${UPDATE_FILE}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

};

const mutations = {};

export default {
    state,
    actions,
    mutations,
    getters
};